require("prismjs/themes/prism-tomorrow.css");

exports.shouldUpdateScroll = () => {
  return true;
};
